<!--
 - Author : 003.
 - Date   : 2019/6/3.
 - File   : datePopover.第一食堂弹窗
 -->

<template>
  <div class="date-popover-wrap" :style="{width: width}">
    <span class="date-popover-wrap-close" @click="close()">
      <i class="iconfont icon-guanbi"></i>
    </span>
    <div class="date-popover-wrap-title" v-if="title">{{title}}
      <el-radio-group v-model="localAocnStatus" size="small" style="margin-left: 20px" v-if="subType==='1201'" @change="changeAocnStatus">
        <el-radio-button label="1">开闸</el-radio-button>
        <el-radio-button label="0">合闸</el-radio-button>
      </el-radio-group>
    </div>
    <div class="msg_date" v-if="dateShow">
      <el-date-picker v-model="date"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptionsDate"
                      :clearable=false
                      @change="selectTimeFn"
                      type="date"
                      placeholder="选择日期">
      </el-date-picker>
    </div>
    <div class="date-popover-wrap-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'datePopover',
  data () {
    return {
      date: this.aqiMsg.date,
      localAocnStatus: '',
      pickerOptionsDate: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      } // 日期范围限制为当前日期之后
    }
  },
  props: {
    title: '',
    width: '',
    aqiMsg: {
      date: ''
    },
    dateShow: {
      default: false
    },
    subType: '',
    deviceId: ''
  },
  watch: {
    aqiMsg() {
      this.date = this.aqiMsg.date
    }
  },
  mounted() {
    if(this.subType === '1201')
    {
      console.log('1201 deviceId' , this.deviceId)
      this.getDeviceDetail()
    }
  },
  methods: {
    /**
     * 获取设备详情
     * @author wuzp
     * @createDate 2019-05-15
     */
    getDeviceDetail(){
      this.$request.deviceGet({'deviceId' : this.deviceId}).then(res => {
        this.localAocnStatus = res.aocnStatus
      }).catch(e => {
        this.$message({
          type: 'error',
          message: e.msg
        })
      })
    },
    /**
     * 分合闸控制
     * @author wuzp
     * @param val
     * @createDate 2019-05-15
     */
    changeAocnStatus(){
      console.log('screen aocnstatus' , this.localAocnStatus, this.deviceId)

      this.$request.mxAocnStatus({'deviceId':this.deviceId ,'aocnStatus':this.localAocnStatus}).then(() => {
        this.getDeviceDetail()
      }).catch(e => {
        this.$message({
          type: 'error',
          message: e.msg
        })
      })
    },
    /**
     * 点击日期事件
     * @author wanghongling
     * @param val
     * @createDate 2019-05-15
     */
    selectTimeFn (val) {
      this.$emit('selectTimeFn', val)
    },
    /**
     * 关闭事件
     * @author wanghongling
     * @createDate 2019-05-15
     */
    close () {
      this.$emit('closeEvent')
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';
  .date-popover-wrap{
    position: relative;
    border-radius: 10px;
    background: rgba(0, 48, 84, .9);
    border: 1px solid #0090ff;
    box-shadow: 0 6px 0 0 rgba(0, 0, 0, .3);
    z-index: 10;
    width: 703px;
    text-align: left;
    min-width: 300px;
    &-close{
      position: absolute;
      top: 10px;
      right: 15px;
      color: @lightBlue;
      cursor: pointer;
      i{
        font-size: 22px;
      }
    }
    &-close:hover{
      opacity: 0.8;
    }
    &-title{
      margin: 2px;
      padding: 10px 20px;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      text-align: left;
      border-radius: 10px;
      /*background: #016cb7;*/
      background: -webkit-linear-gradient(#016cb7, #023b63); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(#016cb7, #023b63); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(#016cb7, #023b63); /* Firefox 3.6 - 15 */
      background: linear-gradient(#016cb7, #023b63); /* 标准的语法 */
    }
    .msg_date {
      position: absolute;
      top: 6px;
      right: 55px;
      .el-input {
        width: 140px;
      }

      .el-input__inner {
        background: #012845;
        border: 1px solid #000;
        color: #fff;
        height: 34px;
        line-height: 34px;
      }
      .el-input__icon{
        line-height: 34px;
      }
    }
    &-content{
      padding: 10px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/datePopover.vue